<template>
    <div>
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
		  	    	<li class="m-nav__item">
		  	    		<router-link :to="{name: 'home'}">
		  	    			<span class="m-nav__link-text">
                    <i class="m-nav__link-icon la la-home"></i>
		  	    			</span>
		  	    		</router-link>
		  	    	</li>
              <li class="m-nav__separator">
		  	    		>
		  	    	</li>
		  	    	<li class="m-nav__item">
		  	    		<span class="m-nav__link-text">
		  	    			{{'traffic_board' | translate | titleize}}
		  	    		</span>
		  	    	</li>
		  	    </ul>
          </div>
          <div>
			  	</div>
        </div>
      </div>
      <div class="m-content">

        <div class="m-portlet m-portlet--head-lg m-portlet--responsive-mobile" id="main_portlet">
          <div class="m-portlet__head padding-head" >
            <div class="m-portlet__head-wrapper display-contents">

              <div class="m-portlet__head-caption" style="width: 25%;">
                <div class="m-portlet__head-title div-border">
                  <h3 class="m-portlet__head-text">
                    <a v-tooltip="messageInfoPresentPersonalTooltip" class="btn btn-outline-primary" data-toggle="modal" data-backdrop="static" data-keyboard="true" data-target="#present_personal_modal" @click.prevent="showPresentPersonal">
                      <i class="fa fa-info"></i>
                    </a> &nbsp;
                    {{'present_personal' | capitalize}}: {{total_present_person}}
                  </h3>
                </div>
              </div>

              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <h3 class="m-portlet__head-text">
                    {{'access' | capitalize}}: {{total_access}}
                  </h3>
                </div>
              </div>

              <div class="row">
                <div :class="[{'has-danger': errors.has(`start_date`)}, 'col-lg-6 element-register']">
                  <label :for="`start_date`">{{'start_date' | translate | capitalize }}</label>
                  <s-date-time-picker :id="`start_date`" :name="'start_date'" v-model="start_date" :options="config_date.start" :placeholder="'AAAA-MM-DD'" @empty="start_date = $event" @input="startDate(start_date)"></s-date-time-picker>
                  <span v-show="errors.has(`start_date`)" class="m-form__help m--font-danger"> {{errors.first(`start_date`)}} </span>
                </div>

                <div :class="[{'has-danger': errors.has(`end_date`)}, 'col-lg-6 element-register']">
                  <label :for="`end_date`">{{'end_date' | translate | capitalize }}</label>
                  <s-date-time-picker :id="'end_date'" :name="'end_date'" v-model="end_date" :options="config_date.end" :placeholder="'AAAA-MM-DD'" @empty="end_date = $event"></s-date-time-picker>
                  <span v-show="errors.has(`end_date`)" class="m-form__help m--font-danger"> {{errors.first(`end_date`)}} </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Inicio mensaje de que no hay movimientos -->
        <div v-if="total_access == 0" class="m-portlet m--bg-brand m-portlet--bordered-semi m-portlet--skin-dark m-portlet--full-height">
          <div class="m-portlet__head">
            <div class="m-portlet__head-caption">
            </div>
          </div>
          <div class="m-portlet__body">
            <div class="m-widget7 m-widget7--skin-dark">
              <div class="align-center" ><i class="flaticon-exclamation-2 icon-size"></i></div>
              <div class="m-widget7__desc info-message">
                {{'empty_movements' | capitalize}}
              </div>
            </div>
          </div>
        </div>
        <!-- Fin mensaje de que no hay movimientos -->

        <!-- Inicio Seccion de tipos de autorizados -->
        <div v-if="total_access > 0" class="m-portlet">
          <div class="m-portlet__body  m-portlet__body--no-padding">
            <div class="row m-row--no-padding m-row--col-separator-xl">
              <div v-for="(authorized_type, index) in authorized_types" :key="index" :class="authorized_type.class">
                <div class="m-widget14 title_board">
                  <div class="m-widget14__header align-center">
                    <h3 class="m-widget14__title font-white">
                      {{authorized_type.name | capitalize}}
                    </h3>
                    <div class="align-center">
                      <div class="under-score-white"></div>
                    </div>
                  </div>
                  <div class="align-items-center">
                    <div class="m-widget14__chart" >
                      <div class="m-widget14__stat m--font-brand font-white">
                        {{authorized_type.total}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row padding-30">
                  <div class="col-lg-6 align-center">
                    <i class="font-white fa fa-sign-in"></i><br>
                    <span class="text-subtitle font-white" >{{'in' | capitalize}}</span><br>
                    <span class="m-board_number font-white">
                      {{authorized_type.in}}
                    </span>
                  </div>
                  <div class="col-lg-6 align-center">
                    <i class="font-white fa fa-external-link"></i><br>
                    <span class="text-subtitle font-white" >{{'out' | capitalize}}</span><br>
                    <span class="m-board_number font-white">
                      {{authorized_type.out}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Seccion de tipos de autorizados -->

        <!-- Inicio Seccion de tipos puntos de control -->
        <div v-if="total_access > 0" class="m-portlet" id="contentControlPoint">
          <div class="m-portlet__body  m-portlet__body--no-padding">
            <div class="row m-row--no-padding m-row--col-separator-xl">
              <div v-for="control_point in control_point_types" :key="control_point.id" class="col-md-12 col-lg col-xl border-blue">
                <div class="m-widget24">
                    <div class="m-widget24__item">
                      <div class="title-custom">
                        <div class="title-custom-icon">
                          <i class="icon--cpt" :class="classIcon(control_point.name)"></i>
                        </div>
                        <div class="title-custom-name">
                          {{control_point.name | capitalize}}
                        </div>
                      </div>
                      <div class="title-custom-value">
                        {{control_point.total}}
                      </div>
                      <div class="m--space-10"></div>
                      <div class="margin-top">
                      </div>
                      <div v-for="(authorized_type,index) in control_point.authorized_types" :key="authorized_type.name">
                        <span class=" margin-left font-black height-30">
                          {{authorized_type.name | capitalize}}
                        </span>
                        <span class="pull-right margin-right font-black height-30">
                          {{authorized_type.total}}
                        </span>
                        <div class="align-center padding-bottom" v-if="index != Object.keys(control_point.authorized_types).length - 1">
                          <div class="under-score-blue"></div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Seccion de tipos puntos de control -->

        <!-- Inicio seccion de Graficos -->
        <div v-if="total_access > 0" class="m-portlet m-portlet--head-overlay m-portlet--full-height  m-portlet--rounded-force" id="contentChart">
          <div class="m-widget14 title_board chart-div">
            <div class="m-widget14__header align-center">
              <h3 class="m-widget14__title">
                {{ 'access_date_chart' | capitalize }}
              </h3>
            </div>
<!--             <div class="m-widget14__header align-center">
              <h3 class="m-widget14__title">
                {{ 'gráfico dos' | capitalize }}
              </h3>
            </div> -->
          </div>
          <div class="m-portlet__body chart-div" ref="chartWidthhh">
            <div class="m-widget27__container" style="width: 40%;">
              <div class="row align-items-center">
                <div class="m-widget27__chart" style="width:100% !important;">
                    <div id="chart" style="width: 100% !important;">
                      <apexchart id="chartAccessDate" ref="chartAccessDate" type=bar width="100%" height=450 :options="chartOptions" :series="series" style="width: 100% !important;" />
                    </div>
                </div>
              </div>
            </div>
            <!-- Segundo gráfico -->
<!--             <div class="m-widget27__container" style="width: 40%;">
              <div class="row align-items-center">
                <div class="m-widget27__chart" style="width:100% !important;">
                    <div id="chart" style="width: 100% !important;">
                      <apexchart id="chartAccessDate" ref="chartAccessDate" type=bar width="100%" height=450 :options="chartOptions" :series="series" style="width: 100% !important;" />
                    </div>
                </div>
              </div>
            </div> -->
            <!-- -->
          </div>
        </div>
        <!-- Fin seccion de Graficos -->

        <!-- Inicion seccion de Puntos de control -->
        <div v-if="total_access > 0" class="m-portlet" id="contentDatatableControlPoint">
          <div class="m-widget14 title_board">
            <div class="m-widget14__header align-center">
              <h3 class="m-widget14__title">
                {{ 'monitoring_control_point' | capitalize }}
              </h3>
            </div>
          </div>
          <div class="m-portlet__body m-portlet__body--no-padding">
            <div class="padding-20">
              <s-datatable :config="datatable" :show_spinner="false">
                <div slot="actions" slot-scope="props">
                  <router-link :to="{ name: 'monitoring', params: { id: props.row.id, name: props.row.name, start_date: start_date, end_date: end_date }}" class="m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit">
                    <i v-tooltip="messageEyeTooltip" class="la la-eye"></i>
                  </router-link>
                </div>
              </s-datatable>
            </div>
          </div>
        </div>
        <!-- Fin seccion de Puntos de control -->

        <!-- Inicio modal -->
        <s-modal id="present_personal_modal" :close_header="true" :title="'present_personal' | translate | capitalize">
          <div class="modal-body" slot="body">
            <section>
              <s-datatable :config="datatable_present" :show_spinner="false">
              </s-datatable>
            </section>
          </div>
        </s-modal>
        <!-- Fin modal -->


      </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SModal from '@/components/layout/modal/Modal.vue'
import SDatatable from '@/components/layout/datatable/Datatable.vue'
let cable = null
export default {
  components: { SModal, SDatatable },
  data () {
    return {
      data: [],
      total_present_person: 0,
      total_access: 0,
      authorized_types: [],
      control_point_types: [],
      datatable: {},
      datatable_present: {},
      chartOptions: {
        chart: {
          id: 'chart'
        },
        xaxis: {
          categories: []
        },
        width: '100%'
      },
      series: [],
      chartWidth: '100%',
      start_date: moment().format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      config_date: {
        start: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: '',
          autoclose: true,
          pickerPosition: 'bottom-left'
        },
        end: {
          format: 'yyyy-mm-dd',
          minView: 2,
          startDate: moment().format('YYYY-MM-DD'),
          autoclose: true,
          pickerPosition: 'bottom-left'
        }
      },
      messageEyeTooltip: this.$options.filters.capitalize('view_detail'),
      messageInfoPresentPersonalTooltip: this.$options.filters.capitalize('message_info_present_personal'),
      company_list: []
    }
  },
  computed: {
    ...mapGetters({shard: 'getUserShard'})
  },
  methods: {
    ...mapActions(['retriveCompany']),
    datatablePresentPerson () {
      const self = this
      const datatable_present = {
        url: '/api/trafic_board/present_personal',
        method: 'POST',
        size: 15,
        columns: [
          {
            field: 'identification_number',
            title: 'identification_number',
            template: function (row) {
              if (row.identification_number) {
                return `DNI ${row.identification_number}`
              } else {
                return `${row.person.identification_number}`
              }
            }
          },
          {
            field: 'person_name',
            title: 'full_name',
            template: function (row) {
              return `${row.person_name}`
            }
          },
          {
            field: 'movement_type',
            title: 'movement_type',
            template: function (row) {
              return '<span class="m-badge m-badge--success m-badge--wide">' + self.$options.filters.capitalize(row.movement_type) + '</span>'
            }
          },
          {
            field: 'company_id',
            title: 'company',
            template: function (row) {
              let company = self.company_list.find(company => company.id === row.company_id)
              let company_name = ''
              if (company !== undefined) {
                company_name = company.name
              } else {
                company_name = 'N/A'
              }
              return company_name
            }
          },
          {
            field: 'create_time',
            title: 'movement_date',
            template: function (row) {
              return moment(self.$options.filters.capitalize(row.created_at)).format('YYYY/MM/DD hh:mm:ss')
            }
          }],
        actions: false,
        update: false,
        query: { config: this.shard }
      }
      this.datatable_present = datatable_present
    },
    initialData () {
      this.$store.dispatch('retrieveDataTraficBoard', { config: this.shard, start_date: this.start_date, end_date: this.end_date })
        .then((res) => {
          const self = this
          this.total_present_person = parseInt(res.data.total_present_person)
          this.total_access = res.data.total_access
          this.authorized_types = res.data.authorized_types
          this.control_point_types = res.data.control_points
          this.data_chart = res.data.chart_data

          if (this.$refs.chartAccessDate === undefined) {
            this.chartOptions.xaxis.categories = res.data.chart_data.hours
            this.series = [{
              name: this.$options.filters.capitalize('in'),
              data: res.data.chart_data.in
            },
            {
              name: this.$options.filters.capitalize('out'),
              data: res.data.chart_data.out
            }]
          } else {
            this.$refs.chartAccessDate.updateOptions({xaxis: {categories: this.data_chart.hours}})
            this.series = [{
              name: this.$options.filters.capitalize('in'),
              data: res.data.chart_data.in
            }, {
              name: this.$options.filters.capitalize('out'),
              data: res.data.chart_data.out
            }]
          }

          if (cable !== null) {
            cable.disconnect()
          }
          if (this.start_date === moment().format('YYYY-MM-DD') && this.end_date === moment().format('YYYY-MM-DD')) {
            var port = window.location.port
            var url = ''
            var cable_port = '3334'
            var location = window.location.href.split('/')[2].split(':')[0]
            if (port === '3000') {
              // Desarrollo
              url = `ws://${location}:${cable_port}/cable`
            } else {
              // Producción
              url = `wss://${location}:${cable_port}/cable`
            }
            cable = ActionCable.createConsumer(url)
            cable.subscriptions.create(
              'TraficBoardChannel',
              {
                connected: function () {

                },
                disconnected: function () {

                },
                received: function (data) {
                  if (self.shard.shard === data.shard) {
                    if (self.shard.profile_id !== 4) {
                      self.total_present_person = parseInt(data.total_present_person)
                      self.total_access = data.total_access
                      self.authorized_types = data.authorized_types
                      self.control_point_types = data.control_points
                      self.data_chart = data.chart_data
                      self.data_chart = data.chart_data

                      if (self.$refs.chartAccessDate === undefined) {
                        self.chartOptions.xaxis.categories = data.chart_data.hours
                        self.series = [{
                          name: self.$options.filters.capitalize('in'),
                          data: data.chart_data.in
                        }, {
                          name: self.$options.filters.capitalize('out'),
                          data: data.chart_data.out
                        }]
                      } else {
                        self.$refs.chartAccessDate.updateOptions({xaxis: {categories: self.data_chart.hours}})
                        self.series = [{
                          name: self.$options.filters.capitalize('in'),
                          data: data.chart_data.in
                        }, {
                          name: self.$options.filters.capitalize('out'),
                          data: data.chart_data.out
                        }]
                      }
                    } else {
                      self.$store.dispatch('retrieveDataTraficBoard', { config: self.shard, start_date: self.start_date, end_date: self.end_date })
                        .then((res) => {
                          self.total_present_person = parseInt(res.data.total_present_person)
                          self.total_access = res.data.total_access
                          self.authorized_types = res.data.authorized_types
                          self.control_point_types = res.data.control_points
                          self.data_chart = res.data.chart_data

                          if (self.$refs.chartAccessDate === undefined) {
                            self.chartOptions.xaxis.categories = res.data.chart_data.hours
                            self.series = [{
                              name: self.$options.filters.capitalize('in'),
                              data: res.data.chart_data.in
                            },
                            {
                              name: self.$options.filters.capitalize('out'),
                              data: res.data.chart_data.out
                            }]
                          } else {
                            self.$refs.chartAccessDate.updateOptions({xaxis: {categories: self.data_chart.hours}})
                            self.series = [{
                              name: self.$options.filters.capitalize('in'),
                              data: res.data.chart_data.in
                            }, {
                              name: self.$options.filters.capitalize('out'),
                              data: res.data.chart_data.out
                            }]
                          }
                        }).catch((res) => {})
                    }
                    self.datatable.query = { config: self.shard, start_date: self.start_date, end_date: self.end_date }
                    self.datatable.update = true
                    self.datatable_present.query = { config: self.shard }
                    self.datatable_present.update = true
                  }
                }
              }
            )
          }

          this.$spinner.remove()
        }).catch((res) => {
          this.$spinner.remove()
        })
      this.retriveCompany()
        .then((res) => {
          this.company_list = res.data
        })
        .catch((res) => {
          console.log(res)
        })
    },
    startDate (value) {
      this.$set(this.config_date.end, 'startDate', value)
      if (this.start_date.replace(':', '') > this.end_date.replace(':', '')) {
        this.end_date = this.start_date
      }
    },
    classIcon (cpt) {
      if (cpt === 'pedestrian') return 'fa fa-male'
      if (cpt === 'handicapped') return 'fa fa-wheelchair'
      if (cpt === 'bikes') return 'fa fa-bicycle'
      if (cpt === 'cargo') return 'fa fa-truck'
      if (cpt === 'vehicle_barrier') return 'fa fa-car'
    },
    showPresentPersonal () {
      this.datatablePresentPerson()
      this.datatable_present.update = true
    }
  },
  created () {
    this.$spinner.show()
    this.initialData()
  },
  mounted () {
    const datatable = {
      url: '/api/trafic_board/control_points',
      method: 'POST',
      size: 15,
      columns: [
        {
          field: 'name',
          title: 'control_point'
        },
        {
          field: 'in',
          title: 'in'
        },
        {
          field: 'out',
          title: 'out'
        }],
      actions: true,
      update: false,
      query: { config: this.shard, start_date: this.start_date, end_date: this.end_date }
    }
    this.datatable = datatable
  },
  update () {

  },
  destroyed () {

  },
  beforeDestroy () {
    if (cable !== null) {
      cable.disconnect()
    }
  },
  watch: {
    start_date () {
      this.$spinner.show()
      this.initialData()
      this.datatable.query = { config: this.shard, start_date: this.start_date, end_date: this.end_date }
      this.datatable.update = true
    },
    end_date () {
      this.$spinner.show()
      this.initialData()
      this.datatable.query = { config: this.shard, start_date: this.start_date, end_date: this.end_date }
      this.datatable.update = true
    }
  }
}
</script>
<style scoped>
.align-center {
  text-align: center
}
.title_board {
  padding: 0rem !important;
}
.padding-15 {
  padding: 15px
}
.padding-20 {
  padding: 20px
}
.padding-30 {
  padding-top: 30px;
  padding-bottom: 30px
}
.text-subtitle {
  font-size: 1rem;
  font-weight: 600;
  color: #575962;
}
.m-board_number {
  font-size: 1.7rem;
  font-weight: 600;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.icon-size {
  font-size: 3rem !important;
}
.info-message {
  margin-top: 1rem !important;
}
.margin-top {
  margin-top: 1.8rem;
}
.border-white {
  border: solid 0.2rem white !important;
}
.border-blue {
  border: solid 2px #232c4b !important;
}

.border-black {
  border-top: solid 0.2rem #000000 !important;
  border-bottom: solid 0.2rem #000000 !important;
  border-left: solid 0.2rem #000000 !important;

}
.margin-left {
  margin-left: 2rem !important;
}
.margin-left-none {
  margin-left: 0rem !important;
}
.margin-right {
  margin-right: 2rem !important;
}
.m-widget24__number {
  margin-left: 1rem !important;
}
.padding-head {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.padding-bottom {
  padding-bottom: 0.5rem;
}
.display-contents {
  display: contents !important;
}
.pointer {
  cursor: pointer;
}
.font-output {
  color: #D91500 !important;
}
.font-input {
  color: #5A00D3 !important;
}
.font-black {
  color: black !important;
}
.font-white {
  color: white !important;
}

.background-blue{
background-color:#1E3A9C !important;
}

.background-green{
background-color:#04A92F !important;
}

.background-red{
background-color:#BA2E2C !important;
}

.background-orange{
background-color:#E55F0D !important;
}

.background-purple{
background-color:#481F64 !important;
}

.background-turquoise{
background-color:#1e999c !important;
}

.background-steel-blue{
background-color:#4a74b4 !important;
}

.under-score-white{
  border-bottom: solid 1px white !important;
  width: 80% !important;
  margin: 0 auto !important;
  height: 10px !important;
  vertical-align: middle !important;
}

.under-score-blue{
  border-bottom: solid 1px #232c4b !important;
  width: 80% !important;
  margin: 0 auto !important;
  height: 10px !important;
  vertical-align: middle !important;
}

.icon--cpt {
  font-size: 3rem !important;
  margin-left: 1rem !important;
}
.title--cpt {
  margin-top: 1rem !important;
}

.showElement{
  opacity:1;
  transition: all .9s ease;
}

.ocultElement{
  opacity:0;
  transition: all .9s ease;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .9s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
.height-30 {
  height: 30px !important;
}

.title-custom {
  width: 100%;
  display: table;
}

.title-custom-icon {
  width: 20%;
  text-align: end;
  font-size: 1.8em;
  padding-top: 15px;
  display: table-cell;
}

.title-custom-name {
  width: 80%;
  text-align: center;
  font-size: 1.2em;
  margin-top: 5px;
  font-weight: 600;
  display: table-cell;
}

.title-custom-value {
  width: 100%;
  text-align: center;
  font-size: 1.75em;
  font-weight: 800;
}

.div-border {
  border: 1px solid black;
  padding: 0.625rem;
  border-radius: 0.25rem;
}

.m-portlet__head-text {
  font-size: 1.1rem !important;
}

.chart-div {
  display: flex;
  justify-content: space-around;
}

</style>



// WEBPACK FOOTER //
// Traffic_board.vue